// extracted by mini-css-extract-plugin
export default {"social_link":"SocialLink_social_link__JBmAO","social_link__icon":"SocialLink_social_link__icon__6gAIo"};